import { render } from "./PlansManagement.vue?vue&type=template&id=7abf6fce&scoped=true"
import script from "./PlansManagement.vue?vue&type=script&lang=js"
export * from "./PlansManagement.vue?vue&type=script&lang=js"

import "./PlansManagement.vue?vue&type=style&index=0&id=7abf6fce&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7abf6fce"]])

export default __exports__